const onSelect = (key, data, isFromCreateApi) => {
  if (isFromCreateApi) {
    setParams(data);
  } else if (key === "") {
    setParams({ ...data });
  } else {
    setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
  }
};

export const handleTabChange = ({ nextTabNo, formData = null, params, activeTab, tenantId, setActiveTab, setShowToast, updateApiCall }) => {
  if (formData) {
    const data = { ...params, ...formData };

    if (activeTab === 0 && nextTabNo === 1 && !("additionalDetails" in params)) {
      Digit.OBPSService.createLandUseUP({ LandUse: data }, tenantId)
        .then((result) => {
          if (result?.LandUse?.length > 0) {
            onSelect("", { ...data, ...result.LandUse[0] }, true);

            setActiveTab(nextTabNo);
            Digit?.SessionStorage.set("currentTab", nextTabNo);
          }
        })
        .catch((e) => {
          setShowToast({ key: "true", error: true, message: e?.response?.data?.Errors[0]?.message });
        });
    } else {
      try {
        if (activeTab === 4) {
          data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
          Modal(
            "Application submitted.",
            `Application <strong>${data?.applicationNo}</strong> Submitted Successfully!`,
            "success",
            "/digit-ui/citizen/profile"
          );
        } else {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
        }
        updateApiCall.mutate(
          { LandUse: data },
          {
            onSuccess: () => {
              onSelect("", data);

              setActiveTab(nextTabNo);
              Digit?.SessionStorage.set("currentTab", nextTabNo);
            },

            onError: () => {
              setShowToast({ error: true, message: `Something went wrong, please try again!` });
            },
          }
        );
      } catch (error) {
        onError(error);
      }
    }
  } else {
    setActiveTab(nextTabNo);
    Digit?.SessionStorage.set("currentTab", nextTabNo);
  }
};
export const filterCategory = (roles) => {
  console.log("rolesFromFilter", roles);
  if (roles) {
    const result = roles.filter((item) => item.name !== "Citizen")[0]?.name;
    console.log("resultFromFIlter", result, roles);

    return roles.filter((item) => item.name !== "Citizen")[0]?.name;
  }
};
export const addYearsToIndianDate = (expiryDate, yearsToAdd, setvalidity) => {
  console.log("expiryFromSub3", expiryDate);

  const [day, month, year] = expiryDate.split("-").map(Number);

  const date = new Date(year, month - 1, day); // month is 0-indexed

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
  }

  date.setFullYear(date.getFullYear() + yearsToAdd);

  const newDay = String(date.getDate()).padStart(2, "0");
  const newMonth = String(date.getMonth() + 1).padStart(2, "0");
  const newYear = date.getFullYear();
  console.log("fromAddYears", `${newDay}-${newMonth}-${newYear}`);

  setvalidity(`${newDay}-${newMonth}-${newYear}`);
};
